import Page from "components/base/Page";
import { createContext, useState } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ExportAll from "./ExportAll";
import { LeftButtons } from "./Header";
import Products from "./Products";
import ProductWarnings from "./ProductWarnings";

export const ProductsPageContext = createContext({});

const ProductProvider = ({ children }) => {
  const [previewProductImages, setPreviewProductImages] = useState(null);

  return (
    <ProductsPageContext.Provider
      value={{ previewProductImages, setPreviewProductImages }}
    >
      {children}
    </ProductsPageContext.Provider>
  );
};

function ProductsIndex() {
  return (
    <ProductProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="index" element={<Products />} />
          <Route path="warnings" element={<ProductWarnings />} />
          <Route path="export" element={<ExportAll />} />
          <Route path="*" element={<Navigate to="index" />} />
        </Route>
      </Routes>
    </ProductProvider>
  );
}

const Layout = () => {
  return (
    <Page className="h-screen" leftButtons={<LeftButtons />}>
      <Outlet />
    </Page>
  );
};

export default ProductsIndex;
